import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	clickedChip: {
		fontWeight: 600,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[500])
	},
	notSentMessageChip: {
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
	},
	sentMessageChip: {
		fontWeight: 600,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[100])
	}
}))

export default useStyles
